// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"34e858e5","241":"c06d697a","453":"768c80ef","969":"29f4957e"}[chunkId] + ".chunk.js";
};